<div class="form-group has-feedback" *ngFor="let field of fields">
  <label class="control-label" [ngClass]="labelClass">{{ field.name }}</label>
  <div [ngClass]="valueClass">
    <p class="form-control-static" style="font-weight:bold">
      <ui-switch *ngIf="isBoolean(field) && canToggle; else plain" size="small" [disabled]="busy"
                 [checked]="rawOf(field) == 'True'" (change)="onToggle(field, $event)"></ui-switch>
      <ng-template #plain>{{ displayOf(field) }}</ng-template>
    </p>
  </div>
</div>
